function makeDemoInitializer(type) {
    const elements = [];
    const NUM_DEMO_ELEMENTS = 5;
    for (let index = 0; index < NUM_DEMO_ELEMENTS; index++) {
        elements.push(makeDemoValue(type));
    }
    return `{${elements.join(", ")}}`;
}

const makeString = function() {
    let stringCount = 1;
    return function() {
        return `"example${stringCount++}"`;
    };
}();

const makeCharacter = function() {
    const firstLetterOffset = 97 - 26;
    let charCode = 96;

    function incrementCharCode() {
        charCode = (charCode + 1 - firstLetterOffset) % 26 + firstLetterOffset;
        return String.fromCharCode(charCode);
    }

    return function() {
        return String.fromCharCode(incrementCharCode());
    };
}();

const makeBoolean = function() {
    let lastBoolean = false;
    return function() {
        lastBoolean = !lastBoolean;
        return lastBoolean;
    };
}();

const makeFloatingPoint = function() {
    return (Math.random() * 10).toFixed(1);
};

const makeInteger = function() {
    const inclusiveMax = 5;
    return Math.round(Math.random() * inclusiveMax);
};

const typeToValue = {
    String: makeString,
    char: makeCharacter,
    boolean: makeBoolean,
    double: makeFloatingPoint,
    float: makeFloatingPoint,
    byte: makeInteger,
    short: makeInteger,
    int: makeInteger,
    long: makeInteger,
    "": () => ""
  };

export function isKnownType(type) {
    const nonArrayType = type.replace(/\[]/g, "");
    return Object.keys(typeToValue).includes(nonArrayType);
}

export function makeDemoValue(type, useInitializer = false) {
    if (Object.keys(typeToValue).includes(type)) {
        return typeToValue[type].call();
    }
    
    if (type.endsWith("[]")) {
        if (useInitializer) {
            return makeDemoInitializer(type.replace("[]", ""));
        } else {
            return `new ${type.replace("[]", "[5]")}`;
        }
    }

    return `new ${type}()`;
}

export function makeClassStubIfUnknown(type) {
    return isKnownType(type) || type === "void" ? "" : `class ${type} { /* your code or imported */ }`;
}